import { Table, Typography } from "antd";

const tableColumns = (data) => {
  let tableColumns = [
    {
      title: "Time",
      dataIndex: "time",
      colSpan: 2,
      align: "left",
      width: 120,
      onCell: (_, index) => ({
        colSpan: 2,
      }),
    },
    {
      title: "",
      colSpan: 0,
      align: "left",
      width: 150,
      onCell: (_, index) => ({
        colSpan: 0,
      }),
    },
  ];

  if (data.length > 0) {
    Object.keys(data[0]).forEach((key, idx) => {
      if (key === "time") return;
      tableColumns.push({
        title: key,
        dataIndex: key,
      });
    });
  }

  return tableColumns;
};

const { Text, Title } = Typography;

export default function TrendTableView({ data, summaryData, themeToken }) {
  const numberFormat = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

  // Function to format the data dynamically (excluding 'time' column)
  const formatData = (data) => {
    return data.map((item) => {
      let formattedItem = { ...item };
      Object.keys(item).forEach((key) => {
        if (key !== "time") {
          formattedItem[key] = item[key].toLocaleString("en-US", numberFormat); // Format numeric values to 2 decimal places and with commas
        }
      });
      return formattedItem;
    });
  };

  // Function to format the summaryData dynamically (excluding 'category' column)
  const formatSummaryData = (summaryData) => {
    return summaryData.map((item) => {
      let formattedItem = { ...item };
      Object.keys(item).forEach((key) => {
        if (key !== "category") {
          formattedItem[key] = item[key].toLocaleString("en-US", numberFormat); // Format numeric values to 2 decimal places and with commas
        }
      });
      return formattedItem;
    });
  };

  // Format the data and summaryData
  const formattedData = formatData(data);
  const formattedSummaryData = formatSummaryData(summaryData);

  return (
    <>
      <Table
        bordered
        size="small"
        columns={tableColumns(formattedData)}
        pagination={{
          pageSize: 10,
          size: "small",
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        dataSource={formattedData}
        summary={() => {
          return (
            formattedSummaryData?.length > 0 && (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell
                    index={0}
                    colSpan={1}
                    rowSpan={formattedSummaryData?.length + 1}
                  >
                    <Text strong>Summary</Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
                {formattedSummaryData.map((row, x) => (
                  <Table.Summary.Row key={x}>
                    {Object.keys(row).map((col, y) => (
                      <Table.Summary.Cell index={y} key={y} width={150}>
                        <Text strong>{row[col]}</Text>
                      </Table.Summary.Cell>
                    ))}
                  </Table.Summary.Row>
                ))}
              </Table.Summary>
            )
          );
        }}
      ></Table>
    </>
  );
}
